import * as pdfjsLib from "pdfjs-dist";

// The worker is copied from node_modules into public/ by scripts/copy-pdf-worker.js
// (runs automatically on npm install via the postinstall hook).
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

// Cache loading tasks so the same PDF (e.g. a multi-page CV rendered as
// several page thumbnails) is only fetched/parsed once. A failed load is
// evicted so the next call retries rather than replaying a rejected promise
// (which would leave the page permanently broken after one transient error).
const docCache = new Map();

export function loadPdfDocument(url) {
  if (!docCache.has(url)) {
    const task = pdfjsLib.getDocument({ url }).promise.catch((err) => {
      docCache.delete(url);
      throw err;
    });
    docCache.set(url, task);
  }
  return docCache.get(url);
}

export default pdfjsLib;
